import {
  GEMINI_VOICE_GENDERS,
  GeminiVoices,
  Gender,
} from '@kanbu/schema/enums';
import { msg } from '@lingui/core/macro';

export const voiceDescriptions = {
  [GeminiVoices.Achernar]: msg`Soft`,
  [GeminiVoices.Achird]: msg`Friendly`,
  [GeminiVoices.Algenib]: msg`Gravelly`,
  [GeminiVoices.Algieba]: msg`Smooth`,
  [GeminiVoices.Alnilam]: msg`Firm`,
  [GeminiVoices.Aoede]: msg`Breezy`,
  [GeminiVoices.Autonoe]: msg`Bright`,
  [GeminiVoices.Callirrhoe]: msg`Easy-going`,
  [GeminiVoices.Charon]: msg`Informative`,
  [GeminiVoices.Despina]: msg`Smooth`,
  [GeminiVoices.Enceladus]: msg`Breathy`,
  [GeminiVoices.Erinome]: msg`Clear`,
  [GeminiVoices.Fenrir]: msg`Excitable`,
  [GeminiVoices.Gacrux]: msg`Mature`,
  [GeminiVoices.Iapetus]: msg`Clear`,
  [GeminiVoices.Kore]: msg`Firm`,
  [GeminiVoices.Laomedeia]: msg`Upbeat`,
  [GeminiVoices.Leda]: msg`Youthful`,
  [GeminiVoices.Orus]: msg`Firm`,
  [GeminiVoices.Puck]: msg`Upbeat`,
  [GeminiVoices.Pulcherrima]: msg`Forward`,
  [GeminiVoices.Rasalgethi]: msg`Informative`,
  [GeminiVoices.Sadachbia]: msg`Lively`,
  [GeminiVoices.Sadaltager]: msg`Knowledgeable`,
  [GeminiVoices.Schedar]: msg`Even`,
  [GeminiVoices.Sulafat]: msg`Warm`,
  [GeminiVoices.Umbriel]: msg`Easy-going`,
  [GeminiVoices.Vindemiatrix]: msg`Gentle`,
  [GeminiVoices.Zephyr]: msg`Bright`,
  [GeminiVoices.Zubenelgenubi]: msg`Casual`,
};

export function getVoicesForGender(gender: unknown): GeminiVoices[] {
  return Object.values(GeminiVoices).filter(voice =>
    gender !== Gender.Male && gender !== Gender.Female
      ? true
      : GEMINI_VOICE_GENDERS[voice] === gender,
  );
}
